import { TaskLinkType } from '@models/tasks/task-link';
import { BaseTaskAction, TaskActionType } from './_base-task-action';
import { Guid, RecursivePartial } from '@models/base';
import { TaskLinkTask } from '../task-link-task';

export class TaskActionLinkRemove extends BaseTaskAction {
    type: TaskActionType.LinkRemove = TaskActionType.LinkRemove;

    linkType?: TaskLinkType;
    taskFromId?: Guid;
    taskToId?: Guid;
    taskFrom?: TaskLinkTask;
    taskTo?: TaskLinkTask;

    constructor(json?: RecursivePartial<TaskActionLinkRemove>) {
        super(json);
        this.parseTaskActionLinkRemove(json || {});
    }

    parse(json: RecursivePartial<TaskActionLinkRemove>): TaskActionLinkRemove {
        super.parse(json);
        this.parseTaskActionLinkRemove(json);
        return this;
    }

    private parseTaskActionLinkRemove(json: RecursivePartial<TaskActionLinkRemove>): void {
        TaskActionLinkRemove.assignFields<TaskActionLinkRemove>(this, json, ['linkType', 'taskFromId', 'taskToId']);
        TaskActionLinkRemove.assignClassFields(this, json, { taskFrom: TaskLinkTask, taskTo: TaskLinkTask });
    }
}
